module.exports = __webpack_public_path__ + "img/logo.7af412d8.png";